"use client";

import { useCallback } from "react";
import { useMsal } from "@azure/msal-react";
import { PORTAL_URL, portalUrl } from "@/lib/portal";

export function useMicrosoftLogin() {
  const { instance } = useMsal();

  // "Sair": o portal está em outra origem e não alcança a sessão deste app, então
  // limpa o cookie e o cache MSAL daqui (a sessão do Entra ID continua, como no
  // logout do portal) e depois vai para o /logout do portal.
  // destination: a <sptech-app-nav> passa a URL do link clicado (ex.: ?mode=switch).
  // Sem portal (NEXT_PUBLIC_PORTAL_IA_URL vazia) não há /logout para onde ir, e a ponte
  // do /login relogaria sozinha pela sessão do Entra ID: sai também da Microsoft.
  const logout = useCallback(async (destination: string = portalUrl("/logout")) => {
    await fetch("/api/auth/session", { method: "DELETE" }).catch(() => undefined);
    if (!PORTAL_URL) {
      await instance.logoutRedirect({ postLogoutRedirectUri: "/login" });
      return;
    }
    await instance.clearCache();
    window.location.assign(destination);
  }, [instance]);

  return { logout };
}
